module.exports = __webpack_public_path__ + "img/icon_login.b058c7dc.svg";